const SIGNATURE_FIELDS = [
  {
    key: 'issued_date',
    name: 'components.lexical.merge_fields.Issued Date',
    placeholder: 'components.lexical.merge_fields.#[Issued Date]',
  },
  {
    key: 'signed_date',
    name: 'components.lexical.merge_fields.Signed Date',
    placeholder: 'components.lexical.merge_fields.#[Signed Date]'
  },
  {
    key: 'assignee_name',
    name: 'components.lexical.merge_fields.Signer Preferred Name',
    placeholder: 'components.lexical.merge_fields.#[Signer Preferred Name]'
  },
  {
    key: 'assignee_legal_name',
    name: 'components.lexical.merge_fields.Signer Name',
    placeholder: 'components.lexical.merge_fields.#[Signer Name]'
  }
]

export default SIGNATURE_FIELDS;
